import * as StringExt from './string';
export { StringExt };
//# sourceMappingURL=index.js.map